import * as Sentry from "@sentry/react";

import { TUser } from "@type/store/AuthStore";

import { ENV } from "@type/config";
import { EENV } from "constants/index";

interface LogErrorProps {
  error?: any;
  traceId: string;
  user: TUser;
}

export const logError = ({ error, traceId, user }: LogErrorProps) => {
  if (ENV === EENV.PROD) {
    Sentry.captureException(
      error?.payload && error?.message
        ? new Error(`API Error: ${error.message}`)
        : error,
      (scope) => {
        scope.setTransactionName(`${traceId} | ${window.location.pathname}`);
        scope.setUser({
          ...scope.getUser(),
          id: user.idUnique,
          email: user.email,
          username: user.fullName,
        });
        scope.setExtras({
          referenceId: error?.data?.ref_id?.replace(/[()]/g, ""),
          traceId: traceId,
          data: error,
        });
        return scope;
      }
    );
  }
};
